import type { SVGProps } from "react";
import { colors } from "./tokens.js";

type MarkProps = Omit<SVGProps<SVGSVGElement>, "children"> & {
  /** Accessible name; omit (or pass "") when the mark sits next to visible brand text. */
  title?: string;
};

/**
 * The two-chevron FlexFreight mark (cream + lime on dark; teal ink + olive in light mode, via the theme tokens), rebuilt as SVG from assets/icon-white.png so
 * it renders on the dark UI without the baked-in black background.
 */
export function LogoMark({ title = "FlexFreight", ...props }: MarkProps) {
  const labelled = title.length > 0;
  return (
    <svg
      viewBox="0 0 296 239"
      role={labelled ? "img" : undefined}
      aria-label={labelled ? title : undefined}
      aria-hidden={labelled ? undefined : true}
      focusable="false"
      {...props}
    >
      <path
        d="M98 4h66a6 6 0 0 1 5 9.4L96 119.5l73 106.1a6 6 0 0 1-5 9.4H98a8 8 0 0 1-6.6-3.5L6.6 123.9a8 8 0 0 1 0-8.8L91.4 7.5A8 8 0 0 1 98 4Z"
        fill={colors.cream}
        style={{ fill: `var(--ff-cream, ${colors.cream})` }}
      />
      <path
        d="M214 4h66a6 6 0 0 1 5 9.4L212 119.5l73 106.1a6 6 0 0 1-5 9.4h-66a8 8 0 0 1-6.6-3.5l-84.8-107.6a8 8 0 0 1 0-8.8L207.4 7.5A8 8 0 0 1 214 4Z"
        fill={colors.lime}
        style={{ fill: `var(--ff-lime, ${colors.lime})` }}
      />
    </svg>
  );
}

type WordmarkProps = { className?: string };

/** "flexFreight" in the display face: "flex" cream, "Freight" lime. Live text, so it scales and is read aloud. */
export function Wordmark({ className }: WordmarkProps) {
  return (
    <span className={className} style={{ fontFamily: "var(--ff-font-display)", fontWeight: 700, letterSpacing: "-0.02em" }}>
      <span style={{ color: "var(--ff-cream)" }}>flex</span>
      <span style={{ color: "var(--ff-lime)" }}>Freight</span>
    </span>
  );
}
